import React from 'react';
import { Lightbulb, TrendingUp, AlertTriangle, Star, Flame, DollarSign, Info } from 'lucide-react';
import type { KpiInsightItem } from '../types';

interface Props {
  insights: KpiInsightItem[];
}

const TYPE_ICONS: Record<string, React.ReactNode> = {
  positive: <TrendingUp size={15} className="text-emerald-600" />,
  warning: <AlertTriangle size={15} className="text-amber-600" />,
  danger: <AlertTriangle size={15} className="text-rose-600" />,
  star: <Star size={15} className="text-amber-500 fill-amber-500" />,
  peak: <Flame size={15} className="text-rose-500" />,
  profit: <DollarSign size={15} className="text-emerald-600" />,
  neutral: <Info size={15} className="text-sky-600" />,
};

const TYPE_BG: Record<string, string> = {
  positive: 'bg-emerald-50/70 border-emerald-200/80 dark:bg-emerald-950/30 dark:border-emerald-800/50',
  warning: 'bg-amber-50/70 border-amber-200/80 dark:bg-amber-950/30 dark:border-amber-800/50',
  danger: 'bg-rose-50/70 border-rose-200/80 dark:bg-rose-950/30 dark:border-rose-800/50',
  star: 'bg-amber-50/70 border-amber-200/80 dark:bg-amber-950/30 dark:border-amber-800/50',
  peak: 'bg-orange-50/70 border-orange-200/80 dark:bg-orange-950/30 dark:border-orange-800/50',
  profit: 'bg-emerald-50/70 border-emerald-200/80 dark:bg-emerald-950/30 dark:border-emerald-800/50',
  neutral: 'bg-sky-50/70 border-sky-200/80 dark:bg-sky-950/30 dark:border-sky-800/50',
};

export const InsightsBanner: React.FC<Props> = ({ insights }) => {
  if (!insights || insights.length === 0) return null;

  return (
    <div className="rounded-2xl border border-emerald-200/80 bg-gradient-to-r from-emerald-50/50 via-surface to-teal-50/30 dark:from-emerald-950/20 dark:to-surface p-4.5 shadow-xs">
      <div className="flex items-center gap-2 mb-3">
        <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-emerald-600 text-white shadow-xs">
          <Lightbulb size={16} />
        </span>
        <div>
          <h3 className="text-sm font-bold text-text">Resumen Ejecutivo & Conclusiones</h3>
          <p className="text-[11px] text-text-muted">
            Análisis automático generado a partir de las cifras de tu negocio en este periodo
          </p>
        </div>
      </div>

      <div className="grid gap-2.5 sm:grid-cols-2 lg:grid-cols-3">
        {insights.map((item, idx) => (
          <div
            key={idx}
            className={`p-3 rounded-xl border text-xs leading-relaxed transition ${
              TYPE_BG[item.type] || TYPE_BG.neutral
            }`}
          >
            <div className="flex items-center gap-1.5 font-bold text-text mb-1">
              {TYPE_ICONS[item.type] || TYPE_ICONS.neutral}
              <span>{item.title}</span>
            </div>
            <p className="text-text/90 font-medium">{item.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
